import AccountProperties from "src/models/account-property";

import _find from "lodash/find";
import _some from "lodash/some";
import _split from "lodash/split";
import _every from "lodash/every";
import _filter from "lodash/filter";
import _findKey from "lodash/findKey";
import _forEach from "lodash/forEach";

const Reports = {
    getReports: function () {
        return [{
            name: "Certified Logs",
            value: "CertifiedLogs",
            type: "Hours of Service",
            id: "certified-logs",
            icon: "fa-calendar-check-o",
            enabled: true
        }, {
            name: "Data Transfer Audit",
            value: "DataTransferAudit",
            type: "Hours of Service",
            id: "data-transfer-audit",
            icon: "fa-copy",
            enabled: true
        }, {
            name: "Driver Logs",
            value: "DriverLogs",
            type: "Hours of Service",
            id: "multiple-driver-logs",
            icon: "fa-group",
            enabled: true
        }, {
            name: "DVIR",
            value: "DVIR",
            type: "DVIR",
            id: "dvir",
            icon: "fa-wrench",
            enabled: true
        }, {
            name: "DVIR Defect Report",
            value: "DvirDefects",
            type: "DVIR",
            id: "dvir-defects",
            icon: "fa-ban",
            enabled: true
        }, {
            name: "Vehicle Daily Usage",
            value: "VehicleDailyUsage",
            type: "Hours of Service",
            id: "vehicle-daily-usage",
            icon: "fa-bus",
            enabled: true
        }, {
            name: "Edit Logs",
            value: "EditLogs",
            type: "Hours of Service",
            id: "edit-logs",
            icon: "fa-pencil-alt",
            enabled: true
        },
        {
            name: "Hours and Miles",
            value: "HoursMiles",
            type: "Hours of Service",
            id: "hours-and-miles",
            icon: "fa-road",
            enabled: true
        }, {
            name: "Hours Worked",
            value: "HoursWorked",
            type: "Hours of Service",
            id: "hours-worked",
            icon: "fa-clock-o",
            enabled: true
        }, {
            name: "Driver's Timecard",
            value: "OnDutyOffDutyEvents",
            type: "Hours of Service",
            id: "onduty-offduty-events",
            icon: "fa-taxi",
            enabled: true
        },
        {
            name: "Driver's Overtime",
            value: "Overtime",
            type: "Hours of Service",
            id: "overtime",
            icon: "fa-solid fa-business-time",
            enabled: true
        },
        {
            name: "Special Moves",
            value: "SpecialMoves",
            type: "Hours of Service",
            id: "special-moves",
            icon: "fa-envelope-open",
            enabled: true

        }, {
            name: "Documents",
            value: "DocumentsReport",
            type: "Hours of Service",
            id: "documents-report",
            icon: "fa-book",
            enabled: true
        }, {
            name: "Invalid Data",
            value: "InvalidData",
            type: "Hours of Service",
            id: "invalid-data",
            icon: "fa-window-close",
            enabled: true
        }, {
            name: "Drivers App Version",
            value: "AppVersion",
            type: "Hours of Service",
            id: "app-version",
            icon: "fa-tablet-alt",
            enabled: true
        }, {
            name: "Driver and Vehicle Information",
            value: "UserAndDriverInfo",
            type: "Hours of Service",
            id: "driver-and-vehicle-info",
            icon: "fa-info-circle",
            enabled: true
        }, {
            name: "Usage",
            value: "usage",
            type: "Hours of Service",
            id: "usage",
            icon: "fa-list-alt",
            enabled: true
        }, {
            name: "Driving Without DVIR",
            value: "DrivingWithoutDvir",
            type: "Hours of Service",
            id: "driving-without-dvir",
            icon: "fa-ban",
            enabled: true
        }, {
            name: "Driving on Open Defect",
            value: "DrivingOnOpenDefect",
            type: "Hours of Service",
            id: "driving-on-open-defect",
            icon: "fa-exclamation-triangle",
            enabled: true
        }, {
            name: "Odometer Jump",
            value: "OdometerJump",
            type: "Hours of Service",
            id: "odometer-jump",
            icon: "fa-tachometer-alt",
            enabled: true
        }, {
            name: "Raw Punch",
            value: "rawPunch",
            type: "Hours of Service",
            id: "raw-punch",
            icon: "fa-calendar",
            enabled: true
        }, {
            name: "Edit Status",
            value: "EditStatus",
            type: "Hours of Service",
            id: "edit-status",
            icon: "fa-file-text",
            enabled: true
        }, {
            name: "VBUS Disconnection",
            value: "VbusDisconnection",
            type: "Hours of Service",
            id: "vbus-disconnection",
            icon: "fa fa-line-chart",
            enabled: true
        }, {
            name: "Fuel & Mileage",
            value: "IFTA",
            type: "State Mileage",
            id: "ifta-report",
            icon: "local_gas_station",
            enabled: true
        }, {
            name: "Mileage by State",
            value: "MileageByState",
            type: "State Mileage",
            id: "mileage-by-state",
            icon: "directions",
            enabled: true
        }, {
            name: "State Mileage Audit",
            value: "IFTAAuditReport",
            type: "State Mileage",
            id: "ifta-audit-report",
            icon: "local_shipping",
            enabled: true
        }, {
            name: "Fuel Summary",
            value: "FuelSummaryReport",
            type: "State Mileage",
            id: "fuel-summary-report",
            icon: "monetization_on",
            enabled: true
        }, {
            name: "Driver and Vehicle Segment",
            value: "DriverVehicleSegment",
            type: "State Mileage",
            id: "driver-vehicle-segment",
            icon: "pie_chart",
            enabled: true
        }, {
            name: "Work Order",
            value: "WorkOrder",
            type: "Mobile Worker",
            id: "work-order-completion",
            icon: "fa-check-square",
            enabled: true
        }, {
            name: "Work Order Summary",
            value: "WorkOrderSummary",
            type: "Mobile Worker",
            id: "work-order-completion-summary",
            icon: "fa-file-text",
            enabled: true
        }];
    },
    loadHiddenReports: function () {
        const deferred = can.Deferred();

        AccountProperties
            .findAll({ name: "hos.hidden.reports" })
            .then(
                responseData => {
                    const reports = this.getReports();

                    const reportsArray = (responseData.length > 0)
                        ? _split(responseData[0].value, ",")
                        : [];

                    _forEach(reportsArray, (value, key) => {

                        // Do the map check.
                        // Is a certain device from the API's response do exist?
                        const isHidden = _some(reports, report => report.value == value);

                        if (isHidden) {
                            const key = _findKey(reports, report => report.value == value);

                            reports[key].enabled = false;
                        }
                    });

                    deferred.resolve(reports);
                },

                responseError => Vistracks.HelperUtils.jqXHR.errorHandler(responseError)
            );

        return deferred.promise();
    },
    hasReportsInGroup: function (hiddenReports, group = "") {
        let reports = this.getReports();

        if (!group) {
            reports = _filter(reports, { type: group });
        }

        return !_every(reports, report => hiddenReports.indexOf(report.value) >= 0);
    }
};

export default Reports;
